/** Events for HelperSidebar ↔ Header (без импорта тяжёлого JSX в Header). */
export const HELPER_SIDEBAR_TOGGLE_EVENT = 'mb_helper_sidebar_toggle';
export const HELPER_SIDEBAR_CLOSE_EVENT = 'mb_helper_sidebar_close';
